import * as types from './types';

export const signIn = (email, password, redirect) => ({
  type: types.AUTH_USER_SIGN_IN,
  email,
  password,
  redirect
});

export const signOut = () => ({
  type: types.AUTH_USER_SIGN_OUT
});

export const initUser = () => ({
  type: types.AUTH_USER_INIT
});

export const syncWithAuthTokens = () => ({
  type: types.AUTH_USER_SYNC_WITH_AUTH_TOKENS
});

export const setLoading = (isLoading = true) => ({
  type: types.AUTH_USER_SET_LOADING,
  isLoading
});

export const setUserData = ({ user, nativeAuthToken, sharedAuthToken }) => ({
  type: types.AUTH_USER_SET_DATA,
  user,
  nativeAuthToken,
  sharedAuthToken
});

export const resetUser = () => ({
  type: types.AUTH_USER_RESET_DATA
});

export const setError = error => ({
  type: types.AUTH_USER_SET_ERROR,
  error
});

export const setUserFromAuthData = authData => ({
  type: types.AUTH_USER_SET_USER_FROM_AUTH_DATA,
  ...authData
});

export const impersonate = userId => ({
  type: types.AUTH_USER_IMPERSONATE,
  userId
});

export const setSignedOutExplicitly = (signedOut = true) => ({
  type: types.AUTH_USER_SET_SIGNED_OUT_EXPLICITLY,
  signedOut
});



// WEBPACK FOOTER //
// ./src/actions/auth-user/index.js